export default __webpack_public_path__ + "static/media/mail.eee1baa7.svg";